import { Colors } from '@auteco/theme'
import MaterialTable from 'material-table'
import React, { useEffect } from 'react'
import { format } from 'date-fns'

const MaterialInfoTable = ({ consolidadoMaterialInfo, leadTime }) => {
  const formatUnixToMonthYear = (unix) => {
    try {
      return format(new Date((unix + 86000) * 1000), 'MMM yy')
    }catch(e){
      return ''
    }
  }


  const data = consolidadoMaterialInfo.map((item, index) => ({
    index: index + 1,
    ajuste_demanda: item.ajuste_demanda || '0',
    venta_historica: item.venta_historica || '0',
    demanda_historica: item.baseline || '0',
    category: item.category || '0',
    sincronizacion: item.sincronizacion || '0',
    inventario_en_sitio: item.inventario_fin_mes || '0',
    costo_historico_promedio: item.costo_unitario || '0',
    mes: ( item.mes_unix && item.mes_unix > 0 )? formatUnixToMonthYear(item.mes_unix) : '',
    gerente: item.gerente || '0',
    junta: item.junta || '0',
    llegada: item.llegadas || '0',
    demanda:
        (parseFloat(item.baseline) || 0) +
        (parseFloat(item.category) || 0) +
        (parseFloat(item.sincronizacion) || 0) +
        (parseFloat(item.ajuste_demanda) || 0) +
        (parseFloat(item.gerente) || 0) +
        (parseFloat(item.junta) || 0) || '0',
  }))

  // Helper function to transform data
  const transformData = (data, rows) => {
    const columns = [
      { title: ' ', field: 'title', headerStyle: {
        backgroundColor: Colors.BLUE,
        color: '#f1f1f1',
        fontSize: '14px',
        fontWeight: 700,
      }  },
      ...data.map((item) => ({ title: item.mes, field: item.mes,  sorting: false,  headerStyle: {
        backgroundColor: Colors.BLUE,
        color: '#f1f1f1',
        fontSize: '12px',
        fontWeight: 700,
      },  
      cellStyle: { width: '80px', minWidth: '80px', height: '50px'  }
    }
    
    ))
    ];

    const transformedData = rows.map((row) => {
      const rowData = { title: row.title };
      data.forEach((item) => {
        // Extract and store only the relevant value for each cell
        rowData[item.mes] = item[row.field];  
      });
      return rowData;
    });

    return { columns, transformedData };
  };

  const transformDataLeadTime = (data, rows) => {
    const columns = [
      { title: ' ', field: 'title', headerStyle: {
        backgroundColor: Colors.BLUE,
        color: '#f1f1f1',
        fontSize: '14px',
        fontWeight: 700,
      }  },
      ...data.map((item, index) => ({ title: item.mes, field: item.mes, sorting: false,  headerStyle: {
        backgroundColor: Colors.BLUE,
        color: index > leadTime ? '#f1f1f1' : "#00faff",
        fontSize: '12px',
        fontWeight: 700,
      },  
      cellStyle: { width: '80px', minWidth: '80px', height: '50px'  }
    }
    
    ))
    ];

    const transformedData = rows.map((row) => {
      const rowData = { title: row.title };
      data.forEach((item) => {
        // Extract and store only the relevant value for each cell
        rowData[item.mes] = item[row.field];  
      });
      return rowData;
    });

    return { columns, transformedData };
  };


  // Data for the first table
  const firstTableData = data.filter(
    (item) => item.index >= 1 && item.index <= 12,
  )
  const rowsForFirstTable = [
    { title: 'Demanda historica', field: 'demanda_historica', },
    { title: 'Venta historica', field: 'venta_historica' },
    {
      title: 'Inventario en sitio',
      field: 'inventario_en_sitio',
    },
    { title: 'Costo historico promedio', field: 'costo_historico_promedio' },
  ]

  // Data for the second table
  const secondTableData = data.filter((item) => item.index >= 13)
  const rowsForSecondTable = [
    { title: 'Ajuste Demanda', field: 'ajuste_demanda' },
    { title: 'Baselines', field: 'demanda_historica' },
    { title: ' Category', field: 'category' },
    { title: 'Gerente', field: 'gerente' },
    { title: 'Sincronizacion', field: 'sincronizacion' },
    { title: 'Junta', field: 'junta' },
    { title: 'Demanda', field: 'demanda' },
  ]

  const firstTable = transformData(firstTableData, rowsForFirstTable)
  const secondTable = transformDataLeadTime(secondTableData, rowsForSecondTable)

  return (
    <>
      <MaterialTable
        title="Pasado"
        data={firstTable.transformedData}
        columns={firstTable.columns}
        options={{
          toolbar: false,
          paging: false, // Desactiva la paginación
          headerStyle: {
            backgroundColor: Colors.BLUE,
            color: '#f1f1f1',
            fontSize: '12px',
            fontWeight: 700,
          },
          rowStyle: (rowData, index) => ({
            backgroundColor: index % 2 === 0 ? 'white' : Colors.GRAY_BACKGROUND,
            padding: '5px', fontSize: '12px'
          }),
        }}
      />
      <MaterialTable
        title="Futuro"
        data={secondTable.transformedData}
        columns={secondTable.columns}
        options={{
          toolbar: false,
          paging: false, // Desactiva la paginación
          rowStyle: (rowData, index) => ({
            backgroundColor: index % 2 === 0 ? 'white' : Colors.GRAY_BACKGROUND,
            padding: '5px', fontSize: '12px'
          }),
        }}
      />
    </>
  )
}

export { MaterialInfoTable }
